/*
 * ZaunScout Produktkonfigurator: Warenkorb
 *
 * Konfigurationen liegen als Gruppe im Warenkorb (Property _konfig_id):
 * - Zusatzprodukte stehen eingerückt unter ihrem Hauptprodukt
 * - Hauptprodukt löschen entfernt die ganze Gruppe
 * - Menge des Hauptprodukts ändern passt gekoppelte Zusätze an (_konfig_pro_stueck)
 */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function getCart() {
    return fetch(ROOT + 'cart.js?t=' + Date.now(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); });
  }

  function updateCart(updates) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) { return response.json(); });
  }

  // Liefert die Änderungen für eine ganze Gruppe oder null, wenn die Zeile kein Hauptprodukt ist
  function groupUpdates(cart, key, qty) {
    var line = (cart.items || []).filter(function (item) { return item.key === key; })[0];
    if (!line || !line.properties || line.properties._konfig_rolle !== 'haupt') return null;

    var id = line.properties._konfig_id;
    var updates = {};
    updates[key] = qty;

    cart.items.forEach(function (item) {
      if (item.key === key || !item.properties || item.properties._konfig_id !== id) return;
      if (qty === 0) {
        updates[item.key] = 0;
      } else if (item.properties._konfig_pro_stueck) {
        updates[item.key] = qty * (parseInt(item.properties._konfig_pro_stueck, 10) || 1);
      }
    });
    return Object.keys(updates).length > 1 ? updates : null;
  }

  function refresh() {
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }

  // Löschen-Link am Hauptprodukt: ganze Gruppe entfernen
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.delete_button a');
    if (!link) return;
    var item = link.closest('.cart__item[data-konfig-rolle="haupt"]');
    if (!item) return;

    event.preventDefault();
    event.stopPropagation();
    var key = item.getAttribute('data-key');

    getCart()
      .then(function (cart) {
        var updates = groupUpdates(cart, key, 0);
        if (!updates) {
          updates = {};
          updates[key] = 0;
        }
        return updateCart(updates);
      })
      .then(refresh, function () { window.location.href = link.href; });
  }, true);

  // Mengenänderung im Warenkorb (Theme-Funktion theme.cart.changeItem)
  function patchTheme() {
    if (!window.theme || !window.theme.cart || window.theme.cart.__zsKonfigurator) return;
    var original = window.theme.cart.changeItem.bind(window.theme.cart);

    window.theme.cart.changeItem = function (key, qty) {
      var quantity = Number(qty);
      return getCart()
        .then(function (cart) {
          var updates = groupUpdates(cart, key, quantity);
          return updates ? updateCart(updates) : original(key, qty);
        })
        .catch(function () { return original(key, qty); });
    };
    window.theme.cart.__zsKonfigurator = true;
  }

  // Zusatzprodukte direkt unter ihr Hauptprodukt sortieren
  function regroup(root) {
    (root || document).querySelectorAll('.cart__item[data-konfig-rolle="haupt"]').forEach(function (main) {
      var id = main.getAttribute('data-konfig-id');
      var anchor = main;
      main.parentNode.querySelectorAll('.cart__item[data-konfig-rolle="zusatz"]').forEach(function (addon) {
        if (addon.getAttribute('data-konfig-id') !== id) return;
        if (anchor.nextElementSibling !== addon) anchor.parentNode.insertBefore(addon, anchor.nextElementSibling);
        anchor = addon;
      });
    });
  }

  function injectStyles() {
    if (document.getElementById('zs-konfigurator-cart-styles')) return;
    var style = document.createElement('style');
    style.id = 'zs-konfigurator-cart-styles';
    style.textContent =
      '.cart__item[data-konfig-rolle="zusatz"]{position:relative;padding-left:22px;}' +
      '.cart__item[data-konfig-rolle="zusatz"]::before{content:"";position:absolute;left:6px;top:0;height:50%;width:12px;' +
      'border-left:2px solid #d6dde5;border-bottom:2px solid #d6dde5;border-bottom-left-radius:8px;}';
    document.head.appendChild(style);
  }

  function init() {
    patchTheme();
    injectStyles();
    regroup(document);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          regroup(document);
          return;
        }
      }
    });
    document.querySelectorAll('#CartDrawer, form[action*="/cart"]').forEach(function (root) {
      observer.observe(root, { childList: true, subtree: true });
    });
  }

  patchTheme();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
